import type { CsatEligibilityData } from './CsatEligibilityData';

const HARD_COOLDOWN_MS: number = 30 * 24 * 60 * 60 * 1000;
const SOFT_COOLDOWN_MS: number = 7 * 24 * 60 * 60 * 1000;

/**
 * Whether the CSAT survey is still within a cooldown window:
 *   - 30-day hard cooldown since the last submit/dismiss (`lastInteractedAt`).
 *   - 7-day soft cooldown since the last shown (`lastShownAt`) — prevents the
 *     survey from re-appearing on every response when the user ignores it.
 */
export const isInCooldown = (data: CsatEligibilityData): boolean => {
	const now = Date.now();
	if (data.lastInteractedAt && now - data.lastInteractedAt < HARD_COOLDOWN_MS) {
		return true;
	}
	if (data.lastShownAt && now - data.lastShownAt < SOFT_COOLDOWN_MS) {
		return true;
	}
	return false;
};
